(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["premium_product_Detail"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ppd').forEach(function(root){
  try {
    var variantsEl = root.querySelector('[data-ppd-variants]');
    var optionsEl = root.querySelector('[data-ppd-options]');
    if(!variantsEl || !optionsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var optionsWithValues = JSON.parse(optionsEl.textContent);
    var maxOptions = Math.min(optionsWithValues.length, 3);
    var selected = [];

    var realOptionsWrap = root.querySelector('[data-ppd-real-options]');
    var priceEl = root.querySelector('[data-ppd-price]');
    var availEl = root.querySelector('[data-ppd-availability]');
    var variantIdInput = root.querySelector('[data-ppd-variant-id]');
    var addBtn = root.querySelector('[data-ppd-add]');
    var toast = root.querySelector('[data-ppd-toast]');
    var form = root.querySelector('[data-ppd-form]');

    var quoteLink = root.querySelector('[data-ppd-quote-link]');
    var baseQuoteHref = quoteLink ? quoteLink.getAttribute('href') : null;
    var hwSelectedValue = null;

    function updateQuoteLink(){
      if (!quoteLink || !baseQuoteHref) return;
      var lines = [];
      optionsWithValues.slice(0, maxOptions).forEach(function(opt, i){
        if (selected[i]) lines.push(opt.name + ': ' + selected[i]);
      });
      if (hwSelectedValue) lines.push('Hardware Finish: ' + hwSelectedValue);
      var body = lines.length
        ? 'Hi Favero team,\n\nI\'d like a custom quote for this configuration:\n\n' + lines.join('\n') + '\n\nThanks!'
        : 'Hi Favero team,\n\nI\'d like a custom quote for this product.\n\nThanks!';
      quoteLink.setAttribute('href', baseQuoteHref + '&body=' + encodeURIComponent(body));
    }

    function moneyFormat(cents){
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    }

    function findVariant(){
      return variants.find(function(v){
        for (var i = 0; i < maxOptions; i++){
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function updateForVariant(){
      var variant = findVariant();
      if (!variant){
        if (addBtn){ addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (availEl) availEl.textContent = variant.available ? 'In stock' : 'Made to order';
      if (addBtn){ addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
      if (variant.featured_image){
        var heroImg = root.querySelector('[data-ppd-hero]');
        if (heroImg) heroImg.src = variant.featured_image.src;
        // sync the thumbnail strip's active state if this image is one of the thumbs
        root.querySelectorAll('[data-ppd-thumb]').forEach(function(t){
          t.classList.toggle('is-active', t.dataset.full.split('?')[0] === variant.featured_image.src.split('?')[0]);
        });
      }
    }

    // ---- Add to Cart wired first, independent of option-picker rendering ----
    if (variantIdInput && variants.length){
      variantIdInput.value = (variants.find(function(v){ return v.available; }) || variants[0]).id;
    }
    if (form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        var formData = new FormData(form);
        if (addBtn){ addBtn.disabled = true; addBtn.textContent = 'Adding...'; }
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
          .then(function(r){
            if (!r.ok) return r.json().then(function(err){ throw new Error(err.description || 'Could not add to cart'); });
            return r.json();
          })
          .then(function(){
            if (toast){ toast.textContent = 'Added to cart.'; toast.classList.add('show'); }
            if (addBtn){ addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
          })
          .catch(function(err){
            if (toast){ toast.textContent = err.message || 'Something went wrong adding this to your cart.'; toast.classList.add('show'); }
            if (addBtn){ addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
            console.error('[Premium Product Detail] add to cart failed:', err);
          });
      });
    }

    // ---- build real (buyable) option pickers, max 3 ----
    try {
      if (!realOptionsWrap) throw new Error('real-options container missing from markup');

      optionsWithValues.slice(0, maxOptions).forEach(function(opt, idx){
        selected[idx] = opt.values[0];
        var isColor = /color|colour|finish/i.test(opt.name);
        var useDropdown = !isColor && opt.values.length > 6;

        var block = document.createElement('div');
        block.className = 'ppd-variant-block';

        var label = document.createElement('div');
        label.className = 'ppd-variant-label';
        label.innerHTML = '<span>' + opt.name + '</span><span data-value-display>' + opt.values[0] + '</span>';
        block.appendChild(label);

        if (useDropdown){
          var select = document.createElement('select');
          select.className = 'ppd-select';
          opt.values.forEach(function(val){
            var o = document.createElement('option');
            o.value = val; o.textContent = val;
            select.appendChild(o);
          });
          select.addEventListener('change', function(){
            selected[idx] = select.value;
            label.querySelector('[data-value-display]').textContent = select.value;
            updateForVariant();
            updateQuoteLink();
          });
          block.appendChild(select);
          realOptionsWrap.appendChild(block);
          return; // next option
        }

        var row = document.createElement('div');
        row.className = isColor ? 'ppd-swatch-row' : 'ppd-pill-row';

        var COLOR_FALLBACK = {
          'white': '#EFEDE7', 'blue': '#3E6E96', 'green': '#1B3B2F', 'charcoal': '#2B2A28',
          'black': '#16151A', 'red': '#7A2E2E', 'grey': '#8A8A82', 'gray': '#8A8A82'
        };

        opt.values.forEach(function(val, vIdx){
          var matchingVariant = variants.find(function(v){ return v.options[idx] === val; });
          var hasPhoto = matchingVariant && matchingVariant.featured_image;
          var el;

          if (isColor){
            el = document.createElement('span');
            el.className = 'ppd-photo-swatch' + (vIdx === 0 ? ' is-selected' : '');
            if (hasPhoto){
              el.style.backgroundImage = 'url(' + matchingVariant.featured_image.src + ')';
            } else {
              el.style.background = COLOR_FALLBACK[val.toLowerCase().trim()] || '#DAD6CC';
            }
          } else {
            el = document.createElement('button');
            el.type = 'button';
            el.className = 'ppd-pill' + (vIdx === 0 ? ' is-selected' : '');
            el.textContent = val;
          }
          el.dataset.value = val;
          el.title = val + (isColor && !hasPhoto ? ' (no product photo assigned to this variant yet)' : '');

          el.addEventListener('click', function(){
            row.querySelectorAll('.is-selected').forEach(function(s){ s.classList.remove('is-selected'); });
            el.classList.add('is-selected');
            selected[idx] = val;
            label.querySelector('[data-value-display]').textContent = val;
            updateForVariant();
            updateQuoteLink();
          });
          row.appendChild(el);
        });

        block.appendChild(row);
        realOptionsWrap.appendChild(block);
      });

      updateForVariant();
      updateQuoteLink();
    } catch (optErr) {
      console.error('[Premium Product Detail] could not render color/material/size pickers:', optErr);
      if (realOptionsWrap && !realOptionsWrap.children.length){
        realOptionsWrap.innerHTML = '<div style="font-size:12px;color:#B00;">Options failed to load — check the browser console for details.</div>';
      }
    }

    // ---- quote-step hardware finish (line-item property, not a variant) ----
    var firstHwPill = root.querySelector('[data-ppd-hw-pill]');
    if (firstHwPill) hwSelectedValue = firstHwPill.dataset.value;
    updateQuoteLink();

    root.querySelectorAll('[data-ppd-hw-pill]').forEach(function(pill){
      pill.addEventListener('click', function(){
        root.querySelectorAll('[data-ppd-hw-pill]').forEach(function(p){ p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var val = pill.dataset.value;
        var valueDisplay = root.querySelector('[data-ppd-hw-value]');
        var hiddenInput = root.querySelector('[data-ppd-hw-input]');
        if (valueDisplay) valueDisplay.textContent = val;
        if (hiddenInput) hiddenInput.value = val;
        hwSelectedValue = val;
        updateQuoteLink();
      });
    });

    // ---- collapsible sections ----
    root.querySelectorAll('[data-ppd-tab-head]').forEach(function(head){
      head.addEventListener('click', function(){
        var tab = head.closest('.ppd-tab');
        tab.classList.toggle('is-open');
      });
    });

    // ---- thumbnail strip: click a thumb to swap the hero image ----
    var heroImgEl = root.querySelector('[data-ppd-hero]');
    root.querySelectorAll('[data-ppd-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        root.querySelectorAll('[data-ppd-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (heroImgEl) heroImgEl.src = thumb.dataset.full;
      });
    });

  } catch (err) {
    console.error('[Premium Product Detail] block failed to initialize:', err);
  }
});
  } catch(e) { console.error(e); }
})();

})();
